import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';
import { GameDto } from '../../../models/game/dto/game.dto';
import { GAME_QUERY_KEY } from './useGetGame';

export const useToggleFullyPaid = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (gameId: number) => {
            return apiClient.fetchApi<GameDto, {}>({
                endpoint: `games/${gameId}/toggle-fully-paid`,
                method: 'POST',
                body: {},
            });
        },
        onSuccess: (data, gameId) => {
            toast({
                title: translate('game.payment_status_updated'),
                description: data.fullyPaid
                    ? translate('game.payment_status_updated_paid')
                    : translate('game.payment_status_updated_not_paid'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });

            // Invalidate and refetch game details to update the UI
            queryClient.invalidateQueries({ queryKey: GAME_QUERY_KEY(gameId) });
        },
        onError: (error: any) => {
            toast({
                title: translate('game.error_updating_payment_status'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
